module.exports = __webpack_public_path__ + "img/obra_over.90acc210.gif";